import { createPortal } from 'react-dom';
import classNames from 'classnames';
import { BadgeState, Button, IconInfo, Text } from '@consumidor-positivo/aurora';
import './styles.scss';
import { SHOffer } from '../../../services/sortingHat';
import { useOfferRedirect } from '../../../hooks/useOfferRedirect';
import { useOfferCard } from '../hooks';
import { getSafeUser } from '../../../helpers/getSafeUser';
import { RedirectModal } from '../../RedirectModal';
import { ExtraFunctionsType } from '../../../types';

type NewCardProps = {
  offer: SHOffer;
  index: number;
  location: string;
  user: any;
  onClickOffer?: ExtraFunctionsType;
};

export const NewCard = ({ offer, index, location, user, onClickOffer }: NewCardProps) => {
  const safeUser = user && getSafeUser(user);
  const { cardRef } = useOfferCard({ offer, index, location, user: safeUser });
  const { isLoading, handleOfferRedirect, handleDetailRedirect, isRedirectModalOpen } = useOfferRedirect({
    location,
    user: safeUser,
    extraFunctions: onClickOffer,
  });

  const {
    generalInfo: { limit, limitMessage, preApproved },
    content: {
      image,
      image_logo,
      is_card_image,
      title,
      title_highlight,
      subtitle,
      feature_information,
      button_text,
      detail_page,
      partner_friendly_name,
      category,
    },
  } = offer;

  const cardSubtitle = title_highlight || limitMessage || subtitle;
  const badgeStatus = limit || preApproved ? 'success' : 'info';
  const badgeText = limit || preApproved ? 'Chance alta de aprovação' : feature_information;
  const showDetailButton = Boolean(detail_page) && Boolean(partner_friendly_name);
  const partnerName = partner_friendly_name || 'o parceiro';

  return (
    <div ref={cardRef} className="creditkit-new-card">
      <div className="creditkit-new-card__content">
        <div
          className={classNames('creditkit-new-card__content__image', {
            'creditkit-new-card__content__image--card': is_card_image || category === 'cards',
          })}
        >
          <img src={image?.filename || image_logo?.filename} alt={image?.alt || title} />
        </div>
        <div className="creditkit-new-card__content__text">
          <div>
            <Text variant="body-small" weight="semibold" color="secondary">
              {title}
            </Text>
            <Text variant="heading-micro" weight="bold">
              {cardSubtitle}
            </Text>
          </div>
          <BadgeState status={badgeStatus} text={badgeText} />
        </div>
      </div>
      <div className="creditkit-new-card__buttons">
        {showDetailButton && (
          <Button type="ghost" onClick={() => handleDetailRedirect(offer, index)}>
            <IconInfo /> Detalhes
          </Button>
        )}
        <Button type="outlined" onClick={() => handleOfferRedirect({ offer, index })} loading={isLoading}>
          {button_text}
        </Button>
      </div>
      {isRedirectModalOpen &&
        createPortal(<RedirectModal isOpen={isRedirectModalOpen} partnerName={partnerName} offerImage={image?.filename || image_logo?.filename || ''} />, document.body)}
    </div>
  );
};
